module.exports = "<a [routerLink]=\"[inputWhere]\"  >\n<i class=\"fa {{kind}} {{size}}\" aria-hidden=\"true\"></i>\n</a>\n"